import { createApp } from "vue";
import VueCookies from "vue-cookies";
import App from "./App.vue";
import router from "./router";
import "./assets/global.css";

const app = createApp(App);

app.use(router);
app.use(VueCookies);

app.directive("alpha-numeric", {
    mounted(el) {
        el.addEventListener("input", function (e) {
            let regex = /^[a-zA-Z0-9\sÀ-ÿ-_]*$/;
            if (!regex.test(e.target.value)) {
                e.target.value = e.target.value.replace(/[^a-zA-Z0-9\sÀ-ÿ-_]/g, "");
            }
        });
    },
});

app.mount("#app");
